import {
  TFilterSelected,
  TListingFetchReason,
  TREQUEST_UPDATE_MACHINE_SERVICE_TASKS,
  TRESPONSE_MACHINE_SERVICE_LIST,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';
import { TMachineServiceInfoActionType } from './machine-service.models';

export class GetMachineServiceList implements Action {
  readonly type = TMachineServiceInfoActionType.GetMachineServiceList;
  constructor(public selectedFilters: TFilterSelected[], public fetchReason: TListingFetchReason) {}
}

export class GetMachineServiceListSuccess implements Action {
  readonly type = TMachineServiceInfoActionType.GetMachineServiceListSuccess;
  constructor(public res: TRESPONSE_MACHINE_SERVICE_LIST, public fetchReason: TListingFetchReason) {}
}

export class GetMachineServiceListFailure implements Action {
  readonly type = TMachineServiceInfoActionType.GetMachineServiceListFailure;
}

export class SetMachineServiceListPagination implements Action {
  readonly type = TMachineServiceInfoActionType.SetMachineServiceListPagination;
  constructor(public pagination: TUserPaginationOption) {}
}

export class UpdateMachineServiceTask implements Action {
  readonly type = TMachineServiceInfoActionType.UpdateMachineServiceTask;
  constructor(public payload: TREQUEST_UPDATE_MACHINE_SERVICE_TASKS) {}
}

export class UpdateMachineServiceTaskSuccess implements Action {
  readonly type = TMachineServiceInfoActionType.UpdateMachineServiceTaskSuccess;
}

export class UpdateMachineServiceTaskFailure implements Action {
  readonly type = TMachineServiceInfoActionType.UpdateMachineServiceTaskFailure;
}

export type TMachineServiceActions =
  | SetMachineServiceListPagination
  | GetMachineServiceList
  | GetMachineServiceListSuccess
  | GetMachineServiceListFailure
  | UpdateMachineServiceTask
  | UpdateMachineServiceTaskSuccess
  | UpdateMachineServiceTaskFailure;
